import React, { useContext } from 'react';
import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';
import PropTypes from 'prop-types';

import { Typography } from '@comparethemarketau/manor-typography';

import { ProviderLogo } from '../../products/products/common/provider_logo';

const useStyles = createUseStyles((theme) => ({
    titleContainer: {
        display: 'flex',
        alignItems: 'center'
    },
    logo: {
        marginRight: theme.spacing[12]
    },
    title: {
        fontSize: theme.fontSize.lg,
        fontWeight: theme.fontWeight.semibold,
        color: theme.colors.primary800
    }
}));

const ContentTitleLogo = ({ title, providerCode }) => {
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });

    return (
        <div className={classes.titleContainer}>
            <ProviderLogo className={classes.logo} code={providerCode} />
            <Typography className={classes.title}>{title}</Typography>
        </div>
    );
};

ContentTitleLogo.propTypes = {
    title: PropTypes.string.isRequired,
    providerCode: PropTypes.string.isRequired
};

export { ContentTitleLogo };
